import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestStrategyEnum } from '@shared/api';
import { FileUtils } from '@shared';

interface IUploadedCreditPdfStore {
  loading: boolean;
  error: string | null;
  getUploadedCreditPdf: (request: { requestId: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUploadedCreditPdfStore = create<IUploadedCreditPdfStore>((set) => ({
  loading: false,
  error: null,

  getUploadedCreditPdf: ApiUtils.wrapperApi(async (request: { requestId: string; filename: string }, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getUploadedCreditPdf(request.requestId, signal);
      FileUtils.downloadFile(result.data, request.filename);
      set({ loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
